/**
 * 课程学习记录
 */

export const CourseCertificateList=[
    {
        prop:"no",
        label:"证书编号",
        width:"150",
        isShow:true
    },
    {
        prop:"name",
        label:"用户姓名",
        width:"100",
        isShow:true
    },
    {
        prop:"phone",
        label:"手机号",
        width:"150",
        isShow:true
    },
    {
        prop:"station",
        label:"岗位角色",
        width:"200",
        isShow:true
    },
    {
        prop:"classHour",
        label:"学习课时",
        width:"100",
        isShow:true
    },
    {
        prop:"provinceName",
        label:"省",
        width:"100",
        isShow:true
    },
    {
        prop:"cityName",
        label:"市",
        width:"100",
        isShow:true
    },
    {
        prop:"regionName",
        label:"区",
        width:"100",
        isShow:true
    },
    {
        prop:"stausTxt",
        label:"状态",
        width:"100",
        isShow:true
    },
    {
        prop:"time",
        label:"创建时间",
        width:"100",
        isShow:true
    }
 ]

